var _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureTankEmptying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 112,
    cy: 43,
    rx: 58,
    ry: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 43v132c0 10 26 18 58 18s58-8 58-18V43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 117c0 10 26 18 58 18s58-8 58-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 117v58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 117v58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 170h28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 163l13 7-13 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 71h74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 65v12M149 65v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 117v58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 117h10M34 175h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 156h19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 151v10M194 151v10"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fontFamily: "Andale Mono, monospace",
    fontSize: 15
  }, /*#__PURE__*/React.createElement("text", {
    x: 101,
    y: 63
  }, "Di\u2081"), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 150
  }, "H\u2080"), /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 146
  }, "Di\u2082"), /*#__PURE__*/React.createElement("text", {
    x: 211,
    y: 175
  }, "Q"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureTankEmptying);
export default __webpack_public_path__ + "static/media/calc-figure-tank-emptying.6d5b312e2d3e3ffdbbe42480e38c0a75.svg";
export { ForwardRef as ReactComponent };